import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";

export function useFeatureFeatureViews(featureId?: string) {
  const { appId } = useEnvironment();

  return useQuery({
    queryKey: featureQueryKeys.featureViews(appId, featureId),

    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/views">(
          `/apps/${appId}/features/${featureId}/views`,
        )
        .then((res) => res.data),
    staleTime: 60 * 60 * 1000,
    enabled: !!appId && !!featureId,
  });
}
